import { CapacitiesGroup } from "../../../../../core";


export const EntityCategory = {
    searchText: 'Buscar categorias',
    export: false,
    filter: false,
    checkbox: true,
    show: 'Aun no hay capacidades que mostrar',
    iconsOfActions: [
        {
            icon: 'cancel',
            tooltip: 'Eliminar capacidad'
        }, 
        {
            icon: 'edit', 
            tooltip: 'Editar capacidad',
            hasVisibleCondition: (element: CapacitiesGroup[]): boolean => {
                return element && element.length && element.length <= 1 ? true : false;
            }
        }
    ],
    columns: [
        {
            title: 'Nombre de la categoria',
            name: 'groupId',
            type: 'string',
            class: 'left',
            value: (element: CapacitiesGroup) => element.groupId
        },
        {
            title: 'Cód. trasportadora',
            name: 'carrier',
            type: 'string',
            class: 'left',
            value: (element: CapacitiesGroup) => element.carrier ? element.carrier.join(' / ') : ''
        },
        {
            title: 'Capacidad',
            name: 'capacity',
            type: 'string',
            class: 'left',
            value: (element: CapacitiesGroup) => element.capacity
        },
        {
            title: 'Categoria valor',
            name: 'subCategory',
            type: 'string',
            class: 'left',
            value: (element: CapacitiesGroup) => element.listCapacities[0].subCategory
        },
        {
            title: 'Lista de atributos',
            name: 'list',
            type: 'string',
            class: 'left',
            value: (element: CapacitiesGroup) => {
                return element.listCapacities.map(i => i.category).join(' / ')
            }
        }
    ]
};
